import React from 'react';

interface AlertRoundIconProps {
  size?: number;
  color?: string;
}

function AlertRoundIcon({
  size = 44,
  color = 'var(--color-error)',
}: AlertRoundIconProps) {
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 22c0 12.15 9.85 22 22 22s22-9.85 22-22S34.15 0 22 0 0 9.85 0 22Zm40 0c0 9.941-8.059 18-18 18S4 31.941 4 22 12.059 4 22 4s18 8.059 18 18ZM22 33.997a2 2 0 1 0 .001-4 2 2 0 0 0 0 4Zm2.007-24h-4.001v16h4.001v-16Z"
        fill={color}
      />
    </svg>
  );
}

export default AlertRoundIcon;
